import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('put', `/api/submissions/${id}/evaluate`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/submitEvaluation.js